var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { namespace } from 'vuex-class';
const app = namespace('app');
let CeTextCards = class CeTextCards extends Vue {
    constructor() {
        super(...arguments);
        this.cssClass = 'ce-text-cards';
    }
    get gridCols() {
        if (this.cards.length >= 3) {
            return 4;
        }
        else if (this.cards.length === 2) {
            return 6;
        }
        return 12;
    }
};
__decorate([
    Prop([Array])
], CeTextCards.prototype, "cards", void 0);
__decorate([
    app.Getter
], CeTextCards.prototype, "portal", void 0);
CeTextCards = __decorate([
    Component
], CeTextCards);
export default CeTextCards;
